import { Component } from '@angular/core';
import { NavController, Platform } from 'ionic-angular';
import { TeamPage } from "../team/team";
import { AngularFirestore } from 'angularfire2/firestore';
import { UserService } from '../../providers/session-service/user-service';

@Component({
  selector: 'page-team-showcase',
  templateUrl: 'team-showcase.html',
})
export class TeamShowcasePage {

  teams: any;
  showSpinner: boolean;

  constructor(public platform: Platform, public navCtrl: NavController, public db: AngularFirestore, private service: UserService) {
    this.showSpinner = false;
    this.platform = platform;
  }

  ionViewDidLoad() {
    this.db.collection("teams", ref => ref.orderBy("position")).valueChanges().subscribe(teams => {
      this.teams = teams;
    });
  }

  selectTeam(team: any) {
    this.navCtrl.push(TeamPage, {
      'team': team
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/team-showcase/team-showcase.ts